import type { QueryKey } from "@tanstack/react-query"

const EParticipantHeaderQueryKey: {
    ModulesExcerpts(): QueryKey
    JourneyAchievements(): QueryKey
} = {
    ModulesExcerpts: (): QueryKey => ["ModulesExcerpts"],
    JourneyAchievements: (): QueryKey => ["JourneyAchievements"]
}

const EParticipantHeaderQueryUrl: {
    ModulesExcerpts(): string
    JourneyAchievements(): string
} = {
    ModulesExcerpts: (): string => "/api/dashboard/all-modules/",
    JourneyAchievements: (): string => "/api/dashboard/achievements/"
}

export { EParticipantHeaderQueryKey, EParticipantHeaderQueryUrl }
